if(document.querySelectorAll('.accessories-tab-title').length > 0){
    document.querySelectorAll('.accessories-tab-title').forEach(function(tabTitle){
      tabTitle.onclick = function(evt){
        var tabHandle = evt.target.getAttribute('data-tab-title');
        document.querySelectorAll('.accessories-tab-title').forEach(function(tabTitleTemp){
          tabTitleTemp.classList.remove('tab-active');
        });
        evt.target.classList.add('tab-active');
        document.querySelectorAll('.accessories-tab-content').forEach(function(tabContentTemp){
          tabContentTemp.classList.remove('tab-content-active');
        });
        document.querySelector('.accessories-tab-content[data-tab-title='+tabHandle+']').classList.add('tab-content-active');
      }
    });
}